// extracted by mini-css-extract-plugin
export default {"tag":"VOyzeUkN8o8X2wHtWAJq","green":"GG6vhhBvJXCKay1py50A","red":"b_W3yiTRvJbkLomyGEnH"};